export default Object.freeze({
    BILL_DAY:{
      ANNIVERSARY:"Anniversary",
      FIRST_OF_THE_MONTH:"1st of the Month"  
    }
  });
  